<template>
  <CCard>
    <CCardHeader style="display: inline-flex">
      <slot name="header" >
       <span class="pt-1"> <CIcon name="cil-grid" /> Phone</span>
      </slot>
      <input class="user-history ml-2"
          v-model="user_phone"
      >
      <CButton class="ml-2" color="primary" @click="showReport" v-if="loading===false">Show</CButton>

    </CCardHeader>
    <CCardHeader>
<!--      <CButton class="center-div btn-block w-50 h-50" color="primary" @click="showReport" v-if="loading===false">Show</CButton>-->

    </CCardHeader>
    <CCardBody v-if="show">
      <v-client-table :data="userHistory" :columns="columns" :options="options">
      </v-client-table>
      <!-- <CButton class="center-div btn-block w-50 h-50" color="primary" v-if="loading===false">Load More</CButton> -->
    </CCardBody>
    <!-- <data-table :headings="columns" :data="revenues" @loadData="loadData"></data-table> -->
  </CCard>
</template>

<script>
import moment from 'moment';
import axios from "axios";
import DataTable from "@/views/base/DataTable.vue";

const ADMIN_URL = process.env.VUE_APP_ADMIN_URL;
export default {
  name: "UserHistory",
 components: { DataTable },

  data() {
    return {
      current_date: moment().clone().format('YYYY-MM-DD hh:mm').toString(),
      date_range:  {
        'start' : null,
        'end' : null
      },
      user_phone:'',
      show: false,
      loading: false,
      selected_report: 'Revenue Report',
      // skip: 0,
      userHistory: [],
      columns: [
        "status",
        "MSISDN",
        "created_at",
        "flag",
        "product_id",

      ],
      options: {
        sortable: [],
        perPage: 10,
        filterByColumn: true,
        toMomentFormat: "YYYY-MM-DD",
        sortIcon: {
          base: "fa fa-sort",
          up: "fa fa-sort-up",
          down: "fa fa-sort-down",
          is: "fa fa-sort",
        },
        // perPageValues:[],

      },
    }
  },
  // mounted:function() {
  //   this.loadingData();
  // },
  methods: {
    // loadData(){
    //   this.loadingData();
    // },
    showReport(){
      this.show=false;
      this.revenues = [];
      // this.skip = 0;
      this.loadingData();
    },
    loadingData(){
      axios({
        method: 'post',
        url: `${ADMIN_URL}/user-history-by-phone`,

        data: {
          phone: this.user_phone,
        }
      })
          .then(response => {
            this.loading = false;
            this.show = true;
            this.userHistory = response.data.data;
            console.log("Hello user history",this.userHistory);

            // console.log(this.revenues);
          })
          .catch(e => {
            console.log("error occurs",e);
          });
    },

  }
}
</script>

<style scoped>
.user-history {
}
</style>
